const copyFallback = input => {
	const el = document.createElement('textarea');

	el.value = input;

	// Prevent keyboard from showing on mobile
	el.setAttribute('readonly', '');

	el.style.contain = 'strict';
	el.style.position = 'absolute';
	el.style.left = '-9999px';
	el.style.fontSize = '12pt'; // Prevent zooming on iOS

	const selection = document.getSelection();
	let originalRange = false;
	if (selection.rangeCount > 0) {
		originalRange = selection.getRangeAt(0);
	}

	// Insérer le textarea au plus près de l'élément actif : dans une modale,
	// le focus trap de ModalRoot rapatrie le focus dès qu'il sort du dialogue,
	// ce qui casserait la sélection d'un élément ajouté au body.
	const container =
		(document.activeElement && document.activeElement.closest('[role="dialog"]')) ||
		document.body;
	container.appendChild(el);
	el.select();

	// Explicit selection workaround for iOS
	el.selectionStart = 0;
	el.selectionEnd = input.length;

	let success = false;
	try {
		success = document.execCommand('copy');
	} catch (err) {}

	container.removeChild(el);

	if (originalRange) {
		selection.removeAllRanges();
		selection.addRange(originalRange);
	}

	return success;
};

export const copy = input => {
	// API moderne : pas de manipulation du focus (indispensable dans les
	// modales dont le focus trap invalide la sélection du fallback).
	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(input).catch(() => copyFallback(input));
		return true;
	}

	return copyFallback(input);
};



// WEBPACK FOOTER //
// ./src/utils/copyToClipboardUtils.js